export default {
      id: "hamburger-usage",
      viewBox: "0 0 32 23",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#hamburger",
      toString: function () {
        return this.url;
      }
    }